export { default } from "./HideMobileAction";
